import { AccordionStack } from 'components/AccordionStack'
import { mockQuestions } from 'constants/HomeConstants'

export const QuestionsSection = () => (
  <div className="pt-14">
    <div className=" mx-auto">
      <p className="text-center title-xl pb-12 ">Got questions? We’ve got answers.</p>
      <AccordionStack questions={mockQuestions} />
    </div>
  </div>
)
